<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Техника</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="form" v-model="valid" :lazy-validation="false">
            <v-autocomplete
              v-model="form.vehicle_type_id"
              :items="vehicleTypes"
              hide-no-data
              hide-selected
              item-text="name"
              item-value="id"
              label="Тип"
              placeholder="Выбрать тип"
              :rules="vehicleTypeRules"
            ></v-autocomplete>
            <v-text-field
              v-model="form.name"
              type="text"
              :rules="nameRules"
              label="Название"
              required
            ></v-text-field>
            <v-autocomplete
              v-model="form.address"
              :items="gecoderValues"
              :loading="gecoderLoading"
              :search-input.sync="gecoderSearch"
              hide-no-data
              hide-selected
              label="Адрес"
              placeholder="Укажите адрес"
              :rules="addressRules"
              auto-select-first
            ></v-autocomplete>

            <div v-if="item && item.photo && item.photo.url">
              <v-img
                :src="item.photo.url"
                :lazy-src="item.photo.url"
                aspect-ratio="1"
                class="grey lighten-2"
                height="125"
                contain
              >
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
              <v-checkbox v-model="form.photo_delete" label="Удалить фото"></v-checkbox>
            </div>

            <v-file-input
              :rules="photoRules"
              accept="image/jpeg, image/png, image/webp, image/gif"
              label="Фото"
              v-model="form.photo"
              prepend-icon="mdi-camera"
              show-size
            ></v-file-input>
            <div class="photo-rules">
              <div class="photo-rules__icons">
                <div class="photo-rules__icon">JPG</div>
                <div class="photo-rules__icon">PNG</div>
                <div class="photo-rules__icon">WebP</div>
                <div class="photo-rules__icon">GIF</div>
              </div>
              <div>Максимальный размер: 10 МБ</div>
              <div>Рекомендуемый размер: 450х450, не более 1000х1000</div>
            </div>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close">Закрыть</v-btn>
        <v-btn color="primary" @click="onSubmit" :loading="submitting">Сохранить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "VehicleDialog",
  data() {
    return {
      item: null,
      dialog: false,
      vehicleTypes: [],
      form: {
        vehicle_type_id: null,
        name: "",
        address: "",
        photo: null,
        photo_delete: false
      },
      valid: true,
      vehicleTypeRules: [v => !!v || "не может быть пустым"],
      nameRules: [v => !!v || "не может быть пустым"],
      addressRules: [v => !!v || "не может быть пустым"],
      addresses: [],
      gecoderLoading: false,
      gecoderSearch: null,
      gecoderValue: null,
      submitting: false,
      photoRules: [
        v => !!v || "не может быть пустым",
        v => !v || ["image/jpeg", "image/jpg", "image/png", "image/webp", "image/gif"].includes(v.type) || "неверный формат изображения",
        v => !v || v.size < 10000000 || "максимальный размер: 10 МБ"
      ]
    };
  },
  computed: {
    gecoderValues() {
      return !this.gecoderValue
        ? this.addresses
        : [this.gecoderValue, ...this.addresses];
    }
  },
  watch: {
    gecoderSearch(value) {
      if (this.isLoading || !value) return;

      this.isLoading = true;
      this.gecoderValue = value;

      this.$api.geocoder
        .select({ address: value })
        .then(response => {
          this.addresses = response.data.map(item => item.description);
        })
        .finally(() => (this.isLoading = false));
    }
  },
  methods: {
    open(item) {
      if (this.$refs.form) this.$refs.form.reset();

      if (item) {
        this.form = {
          vehicle_type_id: item.vehicle_type.id,
          name: item.name,
          address: item.address
        };
        this.gecoderValue = item.address;
        this.item = item;
      }

      this.dialog = true;
      this.fetchData();
    },
    close() {
      this.item = null;
      this.form = {
        vehicle_type_id: null,
        name: "",
        address: "",
        photo: null,
        photo_delete: false
      };
      this.dialog = false;
    },
    fetchData() {
      this.$api.vehicle_types.select().then(response => {
        this.vehicleTypes = response.data.items;
      });
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        if (this.item) {
          this.updateVehicle(this.item.id);
        } else {
          this.createVehicle();
        }
      }
    },
    async createVehicle() {
      this.submitting = true;
      this.$api["contractor/vehicles"]
        .create({
          vehicle_type_id: this.form.vehicle_type_id,
          name: this.form.name,
          address: this.form.address,
          photo: {
            delete: this.form.photo_delete,
            blob: await this.getBase64(this.form.photo)
          }
        })
        .then(() => {
          this.$toast.success(
            "Техника успешно добавлена, после модерации будет доступна для заказа."
          );
          this.$emit("submitted");
          this.close();
        })
        .catch(error => {
          Object.values(error.response.data.errors).forEach(messages => {
            messages.forEach(message => {
              this.$toast.error(message, { icon: "fa-exclamation-circle" });
            });
          });
        })
        .finally(() => (this.submitting = false));
    },
    async updateVehicle(id) {
      this.submitting = true;
      this.$api["contractor/vehicles"]
        .update(id, {
          vehicle_type_id: this.form.vehicle_type_id,
          name: this.form.name,
          address: this.form.address,
          photo: {
            delete: this.form.photo_delete,
            blob: await this.getBase64(this.form.photo)
          }
        })
        .then(() => {
          this.$toast.success("Техника успешно обновлена.");
          this.$emit("submitted");
          this.close();
        })
        .catch(error => {
          Object.values(error.response.data.errors).forEach(messages => {
            messages.forEach(message => {
              this.$toast.error(message, { icon: "fa-exclamation-circle" });
            });
          });
        })
        .finally(() => (this.submitting = false));
    },
    getBase64(file) {
      if (file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
        });
      } else {
        null;
      }
    }
  }
};
</script>

<style lang="scss">
.photo-rules {
  margin-top: 8px;
  padding: 16px;
  background-color: #fafafa;
  border: 1px solid #ddd;
  border-radius: 4px;

  &__icons {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 8px;
  }

  &__icon {
    width: 48px;
    height: 48px;
    padding-top: 22px;
    font-weight: bold;
    text-align: center;
    color: #fff;
    background-image: url("../../../assets/media/file.svg");
  }
}
</style>
